// extracted by mini-css-extract-plugin
module.exports = {"makePillsWrapper":"_126jQ","imageWrapper":"_2gFzi","makeCount":"rKhrC","tabActive":"_1_f5t","allTabActive":"_143gG","partialTabActive":"_13udX","outerBtn":"_1YI5r"};